import React, { useEffect, useState } from "react";
import { ChromePicker } from "react-color";
import "../Services/Services.css";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import UploadIcon from "../../Assets/img/upload.png";
import API from "../Service/Baseservice";
import Loading from "../../Loading/loading";
import FounderPreview from "./FounderPreview";
import CharIcon from "../../Assets/img/word.png";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const aboutMap = {
    1: 4,  // English
    2: 9   // French
};

const FounderEdit = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const initialLanguage = Number(queryParams.get("lang")) || 1;
    const [showPreviewFounder, setShowPreviewFounder] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const languageId = Number(queryParams.get("lang")) || 1;
    const [loading, setLoading] = useState(true);
    const [imagePreview, setImagePreview] = useState(null);
    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "",
    });
    const [formData, setFormData] = useState({
        founder_id: "",
        language_id: languageId,
        about_id: aboutMap[languageId],
        heading: "",
        title: "",
        description: "",
        founder_image: "",
        active: 1,
        updatedBy: 1,
        metricsData: [
            { founderMetrics_id: 1, metrics: "", metrics_value: "" },
            { founderMetrics_id: 2, metrics: "", metrics_value: "" },
            { founderMetrics_id: 3, metrics: "", metrics_value: "" }
        ]
    });

    const [color, setColor] = useState("#000000");
    const [image, setImage] = useState(null);
    const [lastValidDescription, setLastValidDescription] = useState(formData.description);
    useEffect(() => {
        if (!id || !languageId) return;

        setLoading(true);

        API.post("founderListView/condition", {
            language_id: languageId,
            about_id: Number(id),
        })
            .then(res => {
                const founder = res.data?.data?.[0];
                if (!founder) return;

                setFormData({
                    founder_id: founder.founder_id,
                    language_id: founder.language_id,
                    about_id: Number(id),
                    heading: founder.heading || "",
                    title: founder.title || "",
                    description: founder.description || "",
                    founder_image: founder.founder_image || "",
                    active: founder.active ?? 1,
                    updatedBy: 1,
                    metricsData: Array.isArray(founder.founder_metrics)
                        ? founder.founder_metrics
                        : [
                            { founderMetrics_id: 1, metrics: "", metrics_value: "" },
                            { founderMetrics_id: 2, metrics: "", metrics_value: "" },
                            { founderMetrics_id: 3, metrics: "", metrics_value: "" }
                        ],
                });

                setImagePreview(founder.founder_image || null);
            })
            .finally(() => setLoading(false));
    }, [id, languageId]);



    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setLoading(true);

        const reader = new FileReader();
        reader.onload = () => {
            const base64String = reader.result;

            const payload = {
                name: file.name,
                image: [
                    {
                        name: file.name,
                        type: file.type,
                        size: file.size + " bytes",
                        base64: base64String
                    }
                ]
            };

            API.post("imageUpload/add", payload)
                .then((res) => {
                    if (res.data.success) {
                        setFormData({
                            ...formData,
                            founder_image: res.data.url
                        });

                        setImagePreview(res.data.url);
                    } else {
                        setPopup({
                            show: true,
                            title: "Upload Failed",
                            message: "Image upload failed!",
                            type: "error",
                        });
                    }
                })
                .catch(err => {
                    console.error("Upload error:", err);
                    setPopup({
                        show: true,
                        title: "Error",
                        message: "Something went wrong while uploading the image.",
                        type: "error",
                    });
                })
                .finally(() => setLoading(false));
        };

        reader.readAsDataURL(file);
    };

    const handleUpdate = () => {
        if (!formData.heading.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Heading is required!",
                type: "info",
            });
        }

        if (!formData.title.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Title is required!",
                type: "info",
            });
        }

        if (!formData.description.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Description is required!",
                type: "info",
            });
        }

        if (!formData.founder_image) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Founder image is required!",
                type: "info",
            });
        }

        for (let m of formData.metricsData) {
            const metrics = String(m.metrics || "").trim();
            const metricsValue = String(m.metrics_value || "").trim();

            if (!metrics || !metricsValue) {
                return setPopup({
                    show: true,
                    title: "Required",
                    message: "All metrics fields are required!",
                    type: "info",
                });
            }
        }


        setLoading(true);

        API.post("founder_edit/update", formData)
            .then(() => {
                setPopup({
                    show: true,
                    title: "Success",
                    message: "Founder updated successfully!",
                    type: "success",
                });

                setTimeout(() => navigate("/aboutus"), 1500);
            })
            .catch(() =>
                setPopup({
                    show: true,
                    title: "Error",
                    message: "Failed to update founder!",
                    type: "error",
                })
            )
            .finally(() => setLoading(false));
    };
    const getPlainTextLength = (html = "") => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent?.length || 0;
    };

    const handlePreview = () => {
        if (!formData.heading.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Heading is required for preview!",
                type: "info",
            });
        }

        if (!formData.title.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Title is required for preview!",
                type: "info",
            });
        }

        if (!formData.description.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Description is required for preview!",
                type: "info",
            });
        }

        if (!imagePreview) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Please upload founder image before preview.",
                type: "info",
            });
        }

        for (let m of formData.metricsData) {
            if (!String(m.metrics).trim() || !String(m.metrics_value).trim()) {
                return setPopup({
                    show: true,
                    title: "Required",
                    message: "All metrics fields are required!",
                    type: "info",
                });
            }
        }


        setPreviewData({
            heading: formData.heading,
            title: formData.title,
            description: formData.description,
            image: imagePreview,
            metricsData: formData.metricsData,
        });

        setShowPreviewFounder(true);
    };



    return (
        <div>
            <div className="newss-containeradd">
                {/* HEADER BAR */}
                <div className="service-header-bar">
                    <h2 className="services-title1">Edit Founder Profile</h2>

                    <div className="button-group">

                        {/* LANGUAGE SWITCH */}
                        <div className="filter-block">
                            <label>Language</label>
                            <div className="input-container">
                                <select
                                    className="input-field"
                                    value={languageId}
                                    onChange={(e) => {
                                        const newLang = Number(e.target.value);
                                        const newId = aboutMap[newLang];

                                        navigate(`/founderedit/${newId}?lang=${newLang}`, {
                                            replace: true,
                                        });
                                    }}
                                >

                                    <option value={1}>English</option>
                                    <option value={2}>Français</option>
                                </select>
                            </div>
                        </div>
                        <button onClick={handlePreview} className="language-save-btn">
                            Preview
                        </button>
                        <button className="language-save-btn" onClick={handleUpdate}>
                            Save
                        </button>

                        <button
                            style={{ marginTop: "24px" }}
                            onClick={() => navigate("/aboutus")}
                            className="cancel-btn "
                        >
                            Back
                        </button>

                    </div>
                </div>
                {loading ? (
                    <Loading />
                ) : (
                    <>
                        {/* MAIN CONTENT */}
                        <div className="banner-edit-container">

                            {/* Heading */}
                            <div className="aboutus-form-group full-width">
                                <label>Heading <span className="required">*</span></label>
                                <input
                                    type="text"
                                    value={formData.heading}
                                    onChange={(e) => setFormData({ ...formData, heading: e.target.value })}
                                />
                            </div>

                            <div className="aboutus-banner-flex-row">

                                {/* Color Picker */}
                                <div className="color-picker-box-aboutus">
                                    <label>Profile Background Color <span className="required">*</span></label>
                                    <ChromePicker
                                        style={{ marginTop: "25px" }}
                                        color={color}
                                        onChange={(updatedColor) => setColor(updatedColor.hex)}
                                    />
                                </div>

                                {/* UPLOAD IMAGE */}
                                <div className="aboutus-upload-section">
                                    <label>Upload Image <span className="required">*</span></label>
                                    <div className="aboutus-upload-box">
                                        {imagePreview ? <img src={imagePreview} className="preview-img" /> : <><img src={UploadIcon} className="upload-icon" /><p>Click to upload</p></>}
                                        <input type="file" accept="image/*" onChange={handleImageUpload} />
                                    </div>
                                </div>

                                {/* TITLE + DESCRIPTION */}
                                <div className="aboutus-description-section">
                                    <div className="aboutus-form-group">
                                        <label>Title <span className="required">*</span></label>
                                        <input
                                            type="text"
                                            value={formData.title}
                                            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                        />
                                    </div>

                                    <div className="form-group ourfounder-editor-small">
                                        <label className="description-label">
                                            <span className="label-text">
                                                Description <span className="required">*</span>
                                            </span>
                                            <div className="char-wrapper">
                                                <img src={CharIcon} alt="Character count" />
                                                <span className="char-count">
                                                    {getPlainTextLength(formData.description)}/4000
                                                </span>
                                            </div>
                                        </label>

                                        <CKEditor
                                            editor={ClassicEditor}
                                            data={formData.description}
                                            onChange={(event, editor) => {
                                                const html = editor.getData();
                                                const div = document.createElement("div");
                                                div.innerHTML = html;
                                                const textLength = div.textContent?.length || 0;

                                                if (textLength <= 4000) {
                                                    setLastValidDescription(html);
                                                    setFormData({ ...formData, description: html });
                                                } else {
                                                    editor.setData(lastValidDescription);
                                                }
                                            }}
                                            config={{
                                                toolbar: [
                                                    "undo", "redo", "|",
                                                    "heading", "|",
                                                    "bold", "italic", "underline", "|",
                                                    "bulletedList", "numberedList",
                                                ],
                                            }}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                        <br></br>
                        <div className="stats-grid">
                            {formData.metricsData.map((m, index) => (
                                <div className="stat-box" key={index}>
                                    <div className="form-group">
                                        <label>Count <span className="required">*</span></label>
                                        <input
                                            type="text"
                                            value={m.metrics_value}
                                            onChange={(e) => {
                                                const updated = [...formData.metricsData];
                                                updated[index].metrics_value = e.target.value;
                                                setFormData({ ...formData, metricsData: updated });
                                            }}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Title <span className="required">*</span></label>
                                        <input
                                            type="text"
                                            value={m.metrics}
                                            onChange={(e) => {
                                                const updated = [...formData.metricsData];
                                                updated[index].metrics = e.target.value;
                                                setFormData({ ...formData, metricsData: updated });
                                            }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}
                {popup.show && (
                    <div className="popup-overlay">
                        <div className={`popup-box popup-${popup.type}`}>
                            <h3>{popup.title}</h3>
                            <p>{popup.message}</p>
                            <button className="btn ok-btn" onClick={() => setPopup({ ...popup, show: false })}>
                                OK
                            </button>
                        </div>
                    </div>
                )}
                {showPreviewFounder && (
                    <FounderPreview
                        previewService={previewData}
                        setShowPreviewFounder={setShowPreviewFounder}
                    />
                )}
            </div>
        </div>
    );
};

export default FounderEdit;